import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20digital%20security%20landscape%2C%20soft%20geometric%20shapes%20in%20warm%20amber%20and%20teal%20gradients%2C%20clean%20light%20background%2C%20subtle%20texture%2C%20modern%20editorial%20design%2C%20professional%20atmosphere%2C%20elegant%20composition%20with%20flowing%20shapes%20and%20gentle%20curves%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="网络安全资讯"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-6 text-center">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-4 max-w-3xl leading-tight">
          污视频安全资讯平台
        </h1>
        <p className="text-sm md:text-lg text-white/85 max-w-2xl mb-8 leading-relaxed">
          汇集相关资讯、使用说明与安全提示，帮助您识别虚假页面、恶意下载和隐私风险。访问或下载前请确认来源可靠，并遵守当地法律法规。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/safety-tips"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shield-check-line mr-2"></i>浏览安全提示
          </Link>
          <Link
            to="/category/faq"
            className="px-6 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/25 rounded-lg text-sm font-medium hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-question-answer-line mr-2"></i>查看常见问题
          </Link>
        </div>
      </div>
    </section>
  );
}